import React, { useState } from "react";
import { Col, Row, Form, Container } from "react-bootstrap";
import { Navigate, useParams } from 'react-router-dom';
import toast, { Toaster } from "react-hot-toast";
import { toastStyle } from "../../Helpers/Utils/Common";

//components
import Table from "../../Components/TableTemplate/Table";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin"
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import ViewModal from "../../Components/Modals/ViewModal";
import EditModal from "../../Components/Modals/EditModal";
import InputError from "../../Components/InputError/InputError";

//css
import "./CategoryManager.css";

//api
import { refreshPage } from "../../Helpers/Utils/Common";
import { validateCategory } from "../../Helpers/Validation/Admin/CategoryManager";
import { createCategories, deleteCategories, getAllCategories, searchCategories, updateCategories } from "../../Helpers/apiCalls/categoriesManagerApi";
import { useEffect } from "react";
import MytFooter from "../../Components/MytFooter";

export default function CategoryManager() {
  const {id} = useParams();
  const [inactive, setInactive] = useState(false);
  const [option, setOption]= useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  // MODALS //
  // ROWS
  const [selectedRow, setSelectedRow] = useState({});
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  // VIEW
  const [showViewCategoryModal, setShowViewCategoryModal] = useState(false);
  const handleshowViewCategoryModal = () => setShowViewCategoryModal(true);
  const handleCloseViewCategoryModal = () => setShowViewCategoryModal(false);
  // EDIT
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const handleshowEditCategoryModal = () => setShowEditCategoryModal(true);
  const handleCloseEditCategoryModal = () => setShowEditCategoryModal(false);
  // ADD
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const handleshowAddCategoryModal = () => setShowAddCategoryModal(true);
  const handleCloseAddCategoryModal = () => setShowAddCategoryModal(false);
  //API
  const [categories, setCategories] = useState([]);
  const [editCategory, setEditCategory] = useState({});
  const [addCategory, setAddCategory] = useState({
    name: "",
  });

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
  });
  // SEARCH USER
  const [searchUsername, setSearchUsername] = useState("");
  function handleOnSearch(e) {
    // setSearchUsername(e.target.value);
    searchCategory(e.target.value)
  }
       
  //DROPDOWN
  function handleSelectChange(e, row) {
    setSelectedRow(row)
    setEditCategory(row)
    if (e.target.value === "delete-category") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-category") {
      handleshowEditCategoryModal();
    // } else if (e.target.value === "view-user") {
    //   handleshowViewCategoryModal();
    } else {
      refreshPage();
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select name="action" className="PO-select-action form-select" id={row.id} onChange={(e) => handleSelectChange(e, row)} value={option}>
        <option defaulValue selected hidden>Select</option>
        {/* <option value="view-user" className="color-options">View</option> */}
        <option value="edit-category" className="color-options">Edit</option>
        <option value="delete-category" className="color-red">Delete</option>
      </Form.Select>
    );
  }

  // getAllCategories
  async function fetchCategories(){
    setShowLoader(true)
    const response = await getAllCategories();
    if(response.data){
      setCategories(response.data.data.categories)
    }else{
      setCategories([])
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  // getAllCategories
  async function searchCategory(name){
    setShowLoader(true)
    const response = await searchCategories(name);
    if(response.data){
      setCategories(response.data.data)
    }else{
      setCategories([])
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

// ----------------------------------------------------------------------------------------------------------
  //ADD or CREATE CATEGORY
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  //Create API Category
  async function createCategory(){
    if (validateCategory(addCategory, setIsError)) {
      setIsClicked(true);
      const response = await createCategories(addCategory);
      if (response.data) {
        toast.success("Successfully Created Category!", {style: toastStyle(),});
      handleCloseAddCategoryModal();
        refreshPage();
      } else {
        toast.error(response.error.data.messages.error, {style: toastStyle(),});
      }
    } else {
      toast.error("An error has occured!", {style: toastStyle(),});
    }
  }

  //EDIT or UPDATE CATEGORY
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  async function updateCategory(){
    if (validateCategory(editCategory, setIsError)) {
    const response = await updateCategories(editCategory);
      if(response.data){
        toast.success("Successfully Updated Category!", {style: toastStyle(),});
        handleCloseEditCategoryModal()
        refreshPage()
      }else{
          toast.error("Error Updating New Category", {style: toastStyle()})
      }
    }else{
      toast.error("Category name is required!", {style: toastStyle(),});
    }
  }

  //View On Edit Category
  function handleOnEdit(){
    handleCloseViewCategoryModal();
    handleshowEditCategoryModal();        
  }

  //DELETE or REMOVE MENU
  async function handleDeleteCategory() {
    const response = await deleteCategories(selectedRow.id);
    if (response.data) {
      toast.success("Successfully Deleted Category!", {style: toastStyle(),});
      handleCloseDeleteModal();
      refreshPage();
    } else {
      toast.error(response.error.data.messages.error, {style: toastStyle(),});
    }
  }  

  useEffect (() => {
  fetchCategories();
  },[])

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <NavbarAdmin
          onCollapse={(inactive) => {
              setInactive(inactive);
          }}
          active={"Categories"}
          page={"Categories"}
        />
      </div>
      <div className={`container ps-4 pt-4 ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={7}>
            <h1 className="page-title-menu"> CATEGORY MANAGER </h1>
          </Col>
          <Col xs={4} className="d-flex justify-content-end">
            <div class="search-container">
              <input type="text" class="search-input" placeholder="Search category..." name="or_no" onKeyPress={(e)=> e.key === ('Enter' || 'NumpadEnter') && handleOnSearch(e)} onChange={(e)=>handleOnSearch(e)}/>
              <i class="search-icon">&#128269;</i>
            </div>
            {/* <input type="text" class="search-bar-menu" defaultValue="" onKeyPress={(e)=> e.key === ('Enter' || 'NumpadEnter') && handleOnSearch(e)} onChange={(e)=>handleOnSearch(e)}></input> */}
          </Col>
          <Col xs={1} className="center"><button className="add-btn-menu" onClick={handleshowAddCategoryModal}>
              Add
            </button></Col>
        </Row>
        <div className="table-content">
          {/* TABLE */}
          <Table
            tableHeaders={[
              "CATEGORY",
              "ACTIONS",

            ]}
            headerSelector={[
              "name",
            ]}
            tableData={categories}
            ActionBtn={(row)=> ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
      </div>
      {/* MODALS */}
      <DeleteModal
        text="category" 
        show={showDeleteModal} 
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteCategory}
      />
      <AddModal title="CATEGORY" type="user" show={showAddCategoryModal} onHide={handleCloseAddCategoryModal} onSave={createCategory}>
        <div className="mt-3 edit-form">   
          <Row className="nc-modal-custom-row">
            <Col>
              CATEGORY
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                value={addCategory.name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Category is Required"}
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal title="CATEGORY" type="menu" show={showEditCategoryModal} onHide={handleCloseEditCategoryModal} onSave={updateCategory}>
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col xl={12}>
              CATEGORY
              <Form.Control
                type="text"
                name="name"
                // id={editCategory.updated_by}
                value={editCategory.name}
                // defaultValue={selectedRow.name} 
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Category is Required"}
              />
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal  withButtons show={showViewCategoryModal} onHide={handleCloseViewCategoryModal} onEdit={handleOnEdit}>
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              CATEGORY DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col lg={12}>
                  CATEGORY
                  <Row className="nc-modal-custom-row">
                    <Col> {selectedRow.name} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
      <MytFooter/>
    </div>
  );
} 
